import saveAs from "file-saver";
import { RowData, JsonSchema } from "../../../../types";
import { Workbook } from "exceljs";
import { flattenCOARowData } from "../exportCOA/flattenCOARowData";

// TODO: Currently this is a copy of exportCOAToCsv, should be refactored if needed in future
export const exportRecordsToCsv = async (
  rowData: RowData[],
  fileName: string,
  schema: JsonSchema,
): Promise<void> => {
  const flattenedData = flattenCOARowData(rowData, schema);

  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet("Records");

  if (flattenedData.length > 0) {
    const headers = Object.keys(flattenedData[0]);

    worksheet.columns = headers.map((header) => ({
      header,
      key: header,
    }));

    flattenedData.forEach((row) => {
      worksheet.addRow(row);
    });
  }

  const csv = await workbook.csv.writeBuffer();

  const blob = new Blob(["\ufeff", csv], {
    type: "text/csv;charset=utf-8;",
  });

  saveAs(blob, `${fileName}.csv`);
};
